import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../components/Button/Button';
import NonTobaccoUserCreditModal from './NonTabaccoUserCreditModal';

const NonTobaccoUserCreditModalDemo = () => {
  const [showNonTobaccoUserCreditModal, setShowNonTobaccoUserCreditModal] =
    React.useState<boolean>(false);

  const handleShowNonTobaccoUserCreditModal = () =>
    setShowNonTobaccoUserCreditModal(true);
  const handleCloseNonTobaccoUserCreditModal = () =>
    setShowNonTobaccoUserCreditModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Non-Tobacco User Credit Modal</h4>
        <Button onMouseDown={handleShowNonTobaccoUserCreditModal}>
          Open Modal
        </Button>
        <NonTobaccoUserCreditModal
          showNonTobaccoUserCreditModal={showNonTobaccoUserCreditModal}
          handleCloseNonTobaccoUserCreditModal={
            handleCloseNonTobaccoUserCreditModal
          }
        />
      </Container>
    </Container>
  );
};

export default NonTobaccoUserCreditModalDemo;
